import { Checkbox } from "@nextui-org/react";
const examcategoriescolumn = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "name",
    label: "Name",
  },
  {
    key: "exam",
    label: "Exam",
  },
  {
    key: "isLive",
    label: "Status",
  },
  {
    key: "actions",
    label: "Actions",
  },
];

export { examcategoriescolumn };
